import React, { createContext, ReactNode, useContext } from 'react';

type SidebarContextType = {
  openSidebar: (content: ReactNode) => void;
  isSidebarOpen: boolean;
  destroySidebarStack: () => void;
  popSidebar: () => void;
};

export const SidebarContext = createContext<SidebarContextType | null>(null);

export const useSidebarContext = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebarContext must be used within a SidebarProvider');
  }
  return context;
};
